import { render, staticRenderFns } from "./HeaderModular.vue?vue&type=template&id=a31c3e88&scoped=true&"
import script from "./HeaderModular.vue?vue&type=script&lang=js&"
export * from "./HeaderModular.vue?vue&type=script&lang=js&"
import style0 from "./HeaderModular.vue?vue&type=style&index=0&id=a31c3e88&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31c3e88",
  null
  
)

export default component.exports